module.exports = __webpack_public_path__ + "img/card_240720778.e37fe8c9.jpg";